<template>
  <div class="content">
    <NavbarInstrument></NavbarInstrument>
    <v-main>
      <v-container fluid>
        <v-card>
          <template v-slot:title>
            Aplicación Instrumento de Evaluación
          </template>
          <template v-slot:subtitle>
            <div>{{ name }} <v-chip color="primary">{{ type }}</v-chip> - {{ beneficiary.name }} {{ beneficiary.lastname }}</div>
          </template>
          <template v-slot:text>
            <div>{{ description }}</div>
            <div class="mb-5">El siguiente cuestionario es adaptativo, por lo que las preguntas aparecerán una a la vez y el número de preguntas dependerá de tus respuestas, por favor, contesta la siguiente pregunta:</div>
            <v-form ref="form" v-if="question">
              <div class="mb-3">
                <div class="text-h5"><v-chip color="primary">Dimensión: {{ answer.dimension }} - Nivel: {{ answer.nivel }} Pregunta: {{ answer.idpregunta }}</v-chip> {{ question.pregunta }}</div>
                <v-radio-group v-model="answer.respuesta" :rules="[v => !!v || 'Por favor seleeciona una opción de respuesta.']">
                  <v-radio class="text-h6" v-for="(a, i) in onFilter(question)" :key="i" :label="a[0]" :value="{q: a[0], p: a[1]}"></v-radio>
                </v-radio-group>
              </div>
              <v-btn color="primary" @click="onSend()">Enviar</v-btn>
            </v-form>
          </template>
        </v-card>
      </v-container>
    </v-main>
    <!-- Process -->
    <v-dialog v-model="process" max-width="320" persistent >
      <v-list class="py-2" color="primary" elevation="12" rounded="lg" >
        <v-list-item prepend-icon="mdi-clock" title="Espera..." >
          <template v-slot:prepend>
            <div class="pe-4">
              <v-icon color="primary" size="x-large"></v-icon>
            </div>
          </template>
          <template v-slot:append>
            <v-progress-circular color="primary" indeterminate="disable-shrink" size="16" width="2" />
          </template>
        </v-list-item>
      </v-list>
    </v-dialog>
    <!-- validate -->
    <v-dialog v-model="enroll" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="error" icon="mdi-comment-question" size="70" />
        <h2 class="text-h5 mb-3">{{ name }} - {{ type }}</h2>
        <p class="m-4 text-medium-emphasis text-body-2">
          Por favor ingresa tu número de documento:
        </p>
        <div class="text-center">
          <v-text-field v-model="document" color="primary" variant="outlined" :disabled="loading" :rules="rulesdocument"></v-text-field>
          <v-btn variant="tonal" color="primary" :disabled="loading" :loading="loading" @click="onValidate">Buscar</v-btn>
        </div>
      </v-sheet>
    </v-dialog>
    <!-- error -->
    <v-dialog v-model="error.state" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="error" icon="mdi-close-circle" size="112" />
        <h2 class="text-h5 mb-6">Error</h2>
        <p class="mb-4 text-medium-emphasis text-body-2" v-html="error.text"></p>
        <v-divider class="mb-4"></v-divider>
        <div class="text-end">
          <v-btn class="text-none" color="error" variant="flat" text="Aceptar" @click="error.state = false"/>
        </div>
      </v-sheet>
    </v-dialog>
    <!-- failed -->
    <v-dialog v-model="failed.state" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="error" icon="mdi-calendar-remove" size="112" />
        <h2 class="text-h5 mb-3">Parece que ha ocurrido un error</h2>
        <p class="m-4 text-medium-emphasis text-body-2">
          {{  failed.text  }}
        </p>
        <div class="text-center">
          <v-btn class="text-none" color="error" variant="plain" prepend-icon="mdi-open-in-new" text="www.unitedwaycolombia.org" @click="openlink('https://unitedwaycolombia.org')"/>
        </div>
      </v-sheet>
    </v-dialog>
  </div>
</template>
<script setup>
  import NavbarInstrument from '@/components/navbar/NavbarInstrument.vue';
  import axios from 'axios';
  import Params from '@/models/params';
  import { ref, reactive, onMounted } from 'vue';

  const params = ref(new Params);
  const name = localStorage.instrumentName;
  const type = localStorage.instrumentType;
  const instrument = localStorage.instrumentId;
  const assessment = localStorage.instrumentAssesment;
  const description = localStorage.instrumentDescription;
  const process = ref(false);
  const loading = ref(false);
  const enroll = ref(true);
  const form = ref()
  const document = ref(null);
  const setting = ref([]);
  const question = ref();
  const answers = ref([]);

  const it = ref([0, 0, 0]);
  const dm = ref({});
  const pk = reactive({
    competencia: 0,
    dimension: 0,
    nivel: 0,
    cantidad_preguntas: 0,
    preguntas_realizadas: [],
    acierto: 0,
  });
  const answer = reactive({
    competencia: 0,
    dimension: 0,
    nivel: 0,
    idpregunta: 0,
    respuesta: {}
  });

  const failed = reactive({
    state: null,
    text: null
  })

  const error = reactive({
    state: null,
    text: null
  })

  const beneficiary = ref({
    enroll: 0,
    name: null,
    lastname: null,
    document: null
  });

  const rulesdocument = [
    value => {
      const pattern = /^\d{7,15}$/
      return pattern.test(value) || 'Invalid document.'
    }
  ]

  onMounted(() => {
    it.value = [0, 0, 0];
  });

  async function onValidate(){
    if (document.value) {
      loading.value = true;
      const frm = new FormData;
      frm.append('document', document.value);
      frm.append('assessment', assessment);
      await axios.post(params.value.api + 'instrumentos/beneficiario', frm)
      .then( r => {
        enroll.value = false;
        if (r.data.status) {
          const d = r.data.data;
          beneficiary.value.enroll = d.idmatricula;
          beneficiary.value.name = d.nombres;
          beneficiary.value.lastname = d.apellidos;
          beneficiary.value.document = d.documento_numero;
          onSetting();
        }else{
          failed.text = r.data.message;
          failed.state = true;
        }
      })
      .catch( (err) => {
        failed.text = err.message;
        failed.state = true;
      });
    }
  }

  async function onSetting(){
    try {
      const frm = new FormData;
      frm.append('instrument', instrument);
      await axios.post(params.value.api + 'instrumentos/configuracion', frm)
      .then( r => {
        if(r.data.status){
          //Mapear estructura
          let i = 0, j = 0;
          let item = [];
          for (const e of r.data.data) {            
            if(item.length === 0){
              item.push({
                "skill": e.idcompetencia,
                "dimensions": [{
                  "id": e.idestadio,
                  "levels": [],
                  "amount": []
                }]
              });
              item[i].dimensions[j].levels.push(e.idnivel);
              item[i].dimensions[j].amount.push(e.cantidad);
              continue;
            }
            if(e.idcompetencia !== item[i].skill){
              i++;
              j = 0;
              item.push({
                "skill": e.idcompetencia,
                "dimensions": [{
                  "id": e.idestadio,
                  "levels": [],
                  "amount": []
                }]
              });
              item[i].dimensions[j].levels.push(e.idnivel);
              item[i].dimensions[j].amount.push(e.cantidad);

            }else if(e.idestadio !== item[i].dimensions[j].id){
              item[i].dimensions.push({
                "id": e.idestadio,
                "levels": [],
                "amount": []
              });
              j++;
              item[i].dimensions[j].levels.push(e.idnivel);
              item[i].dimensions[j].amount.push(e.cantidad);
            }else{
              item[i].dimensions[j].levels.push(e.idnivel);
              item[i].dimensions[j].amount.push(e.cantidad);
            }
          }
          setting.value = item;
          //console.log(setting.value);
          loading.value = false;
          onQuestion();
        }        
      });
    } catch (err) {
      failed.text = err;
      failed.state = true;
    }
  }

  async function onSend(){
    try {      
      if(it.value[0] >= setting.value.length){
        process.value = true;
        console.log('Enviar respuestas!');
      }else{
        answers.value.push(answer.value);
        if(answer.respuesta.p == 10){
          pk.acierto++;
        }
        onQuestion();
      }
    } catch (err) {
      failed.text = err;
      failed.state = true;
    }
  }

  function onQuestion(){
    try {
      const ps = setting.value[it.value[0]];
      console.log(dm.value);

      pk.cantidad_preguntas = ps.dimensions[it.value[1]].amount[it.value[2]];
      pk.competencia = ps.skill;
      pk.dimension = ps.dimensions[it.value[1]].id;
      pk.nivel = ps.dimensions[it.value[1]].levels[it.value[2]];

      const porcentaje_acierto = (pk.acierto * 100) / pk.cantidad_preguntas;
      const probabilidad = ( porcentaje_acierto + ((( pk.cantidad_preguntas - pk.preguntas_realizadas.length ) * 100 ) / pk.cantidad_preguntas) );
      
      if((porcentaje_acierto >= 51) || ( probabilidad < 51 )){
        if(porcentaje_acierto >= 51){
          dm.value[pk.dimension] = { dimension: pk.dimension, nivel: pk.nivel, estado: true };
          if(it.value[2] < (ps.dimensions[it.value[1]].levels.length - 1)){
            console.log('Cambiar nivel');
            it.value[2]++;
          }else{
            if(it.value[1] < (ps.dimensions.length - 1)){
              console.log('Cambiar dimensión');
              it.value[2] = 0;
              it.value[1]++;
            }else{              
              console.log('Cambiar competencia');
              it.value[2] = 0;
              it.value[1] = 0;
              it.value[0]++;
            }            
          }            
        } else {
          if(!dm.value[pk.dimension]){
            dm.value[pk.dimension] = { dimension: pk.dimension, nivel: pk.nivel, estado: false };
          }
          if(it.value[1] < (ps.dimensions.length - 1)){
            console.log('Cambiar dimensión');
            it.value[2] = 0;
            it.value[1]++;
          }else{              
            console.log('Cambiar competencia');
            it.value[2] = 0;
            it.value[1] = 0;
            it.value[0]++;
          }
        }
        pk.preguntas_realizadas = [];
        pk.acierto = 0;
        console.log(dm.value[pk.dimension].estado);
        onQuestion();
      } else{
        console.log('Cargar pregunta');
        getQuestion();
      }

    } catch (err) {
      failed.text = err;
      failed.state = true;
    }
  }

  async function getQuestion(){
    process.value = true;
    const frm = new FormData;
    frm.append('level', pk.nivel);
    frm.append('made', JSON.stringify(pk.preguntas_realizadas));
    await axios.post(params.value.api + 'instrumentos/pregunta', frm)
    .then( r => {
      if(r.data.status){
        const d = r.data.data;
        const random = sortAnswers([ 
          [d.opcion1, d.peso1], 
          [d.opcion2, d.peso2], 
          [d.opcion3, d.peso3], 
          [d.opcion4, d.peso4], 
          [d.opcion5, d.peso5] 
        ])
        question.value = {
          id: d.id,
          codigo: d.codigo,
          nivel: d.idnivel,
          idpregunta: d.idpregunta,
          pregunta: d.pregunta,
          tipo: d.tipo,
          respuestas: random,
          respuesta: []
        };
        answer.competencia = pk.competencia;
        answer.dimension = pk.dimension;
        answer.nivel = pk.nivel;
        answer.idpregunta = d.idpregunta;
        pk.preguntas_realizadas.push(answer.idpregunta);
        process.value = false;
      }else{
        console.log(r.data.message);
      }
    });
    process.value = false;

    //console.log(pk);
  }

  function onFilter(question){
    return question.respuestas.filter(respuesta => respuesta[0]); 
  }

  function sortAnswers(opciones) {
    return opciones.sort(() => Math.random() - 0.5);
  }

</script>